import { extendObservable } from 'mobx'

class QueueProcessorStore {
  constructor (userStore, socket) {
    this.socket = socket

    extendObservable(this, {
      jobs: {},
      userStore
    })

    this.socket.on('bsJobFinished', ({ jobId, data }) => {
      if (!this.jobs[jobId]) return
      this.jobs[jobId].data = data
      this.jobs[jobId].loading = false
      if (this.jobs[jobId].onSuccess) this.jobs[jobId].onSuccess(data)
    })

    this.socket.on('bsJobError', ({ jobId, error }) => {
      if (!this.jobs[jobId]) return
      this.jobs[jobId].error = error
      this.jobs[jobId].loading = false
      if (this.jobs[jobId].onError) this.jobs[jobId].onError(error)
    })
  }

  trackJob = (jobId, onSuccess, onError) => {
    extendObservable(this.jobs, {
      [jobId]: {
        loading: true,
        data: null,
        error: null,
        onSuccess,
        onError
      }
    })
    return this.jobs[jobId]
  }
}

export default QueueProcessorStore
